import * as tslib_1 from "tslib";
import React from 'react';
import { connect } from 'formik';
import PropTypes from 'prop-types';
import FormStateWithFormName from './FormStateWithFormName';
/**
 * 表单状态监听组件
 *
 */
var FormState = function (props, _a) {
    var sinouiForm = _a.sinouiForm;
    var children = props.children, formName = props.formName, formik = props.formik;
    if (formName && typeof props.children === 'function') {
        return (React.createElement(FormStateWithFormName, tslib_1.__assign({}, props), children));
    }
    // tslint:disable-next-line:no-any
    formik.isValid = !Object.keys(formik.errors).some(function (key) { return formik.errors[key]; });
    return typeof children === 'function'
        ? children(formik, sinouiForm)
        : React.cloneElement(React.Children.only(children), { formik: formik, sinouiForm: sinouiForm });
};
FormState.contextTypes = {
    sinouiForm: PropTypes.object,
};
export default connect(FormState);
//# sourceMappingURL=FormState.js.map